import HarmoniqIcon from "../Icons/harmoniqIcon.jsx";

export default function OAuthPopup() {
  return (
    <div className="app-route-loader" aria-live="polite" aria-busy="true">
      <HarmoniqIcon size={56} className="app-route-loader-icon" />
    </div>
  );
}
